import React from 'react';

import { Grid, Container, Typography, Button } from '@material-ui/core';

export default ({ onDismiss }) => {
  return (
    <Grid container component={Container} className="py-3" style={{ width: '21rem' }}>
      <Grid item>
        <Typography className="page-header mb-1" align="center">
          Estimated Report Delivery
        </Typography>
      </Grid>
      <Grid item>
        <Typography className="body-copy mb-1" align="center">
          This is the earliest date you would like to get your video report. You may want to get your report ASAP or you may prefer to have the report come after you have heard
          from your doctor at a follow-up appointment in which case you can set a delivery delay.
        </Typography>
      </Grid>
      <Grid item xs={12} container justify="center">
        <Button onClick={onDismiss} color="primary" variant="contained" style={{ width: '9rem' }}>
          Dismiss
        </Button>
      </Grid>
    </Grid>
  );
};
